export interface AttendanceEntry {
  company: string;
  person: string;
}

export interface ManualAttendanceSubmission {
  method: "manual";
  data: {
    index_name: "company_event" | "company_person_event";
    document: Record<string, unknown>;
  };
}

export const buildAttendanceSubmission = (
  entry: AttendanceEntry,
  eventName: string,
): ManualAttendanceSubmission => {
  const company = entry.company.trim();
  const person = entry.person.trim();
  const conference = eventName.trim();

  if (!company || !conference) {
    throw new Error("Company and conference names are required");
  }

  if (!person) {
    return {
      method: "manual",
      data: {
        index_name: "company_event",
        document: {
          company: { name: company },
          event_name: conference,
        },
      },
    };
  }

  return {
    method: "manual",
    data: {
      index_name: "company_person_event",
      document: {
        person: {
          name: person,
          company: { name: company },
        },
        event_name: conference,
      },
    },
  };
};
